import axios from "axios";
import { LOGIN, MAINTENANCE } from "@routes/routes";
import { API_BASE_URL, API_URL } from "@config/app";
import { isClientPanelHostname } from "@hooks/useClientPanel";

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    const originalRequest = error.config;

    if (status === 401) {
      // The patient panel has no login screen — let the page's own error
      // handling take over instead of redirecting to a 404.
      if (!isClientPanelHostname()) {
        window.location.href = LOGIN;
      }
      return Promise.reject(error);
    }

    if (status === 419 && !originalRequest._retry) {
      originalRequest._retry = true;
      await axios.get(`${API_URL}/csrf-cookie`);
      return axios(originalRequest);
    }

    if (status === 503 && window.location.pathname !== MAINTENANCE) {
      window.location.href = MAINTENANCE;
    }

    return Promise.reject(error);
  },
);

export default axios;
